import React, { useState } from 'react'
import { CiEdit } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import ModalEditStages from './Modals/ModalEditStages';
import ModalEditProbes from './Modals/ModalEditProbes';
import ModalEditQuestions from './Modals/ModalQuestions';
import { useSelector, useDispatch } from 'react-redux';
import { getStages } from 'actions/WorkFlowActions';
import { ROLES } from 'utils';

const CardTitle = ({ name }) => (
  <div className="absolute -top-5 left-4 h-12 w-96 flex items-center pl-4 truncate rounded-lg text-white font-bold bg-[#dbbf26] shadow-md">
    {name}
  </div>
)

const DetailsWorkFlows = () => {
  const dispatch = useDispatch();
  const { stages, workFlowSelected } = useSelector(state => state.workFlow)
  const { role } = useSelector(state => state.auth)
  const [selectedStage, setSelectedStage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalProbesOpen, setIsModalProbesOpen] = useState(false);
  const [isModalQuestionsOpen, setIsModalQuestionsOpen] = useState(false);
  const [pollSelected, setPollSelected] = useState(0);
  const [titlePoll, setTitlePoll] = useState("");

  if (!workFlowSelected) return null;
  return (
    <>
      <div className="relative h-full w-full rounded-lg shadow-xl shadow-gray-400 p-4 bg-white">
        <CardTitle name={workFlowSelected.name} />
        <div className="h-10 w-full mt-6 flex flex-row justify-between items-center">
          <span className='text-gray-500 text-[16px] font-semibold'>Etapas</span>
          <div
            className='h-8 w-44 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]'
            onClick={() => setIsModalOpen(true)}
          >
            Editar Etapas <CiEdit className='ml-2 size-6' />
          </div>
        </div>
        <div className='h-5/6 w-full mt-1 pt-4 overflow-auto flex flex-col items-center'>
          {
            stages.map((item, index) => (
              <div key={index} className='mb-5 w-full flex flex-col items-center'>
                <div
                  className='h-14 w-11/12 flex justify-between items-center bg-gray-600 text-gray-300 rounded-lg cursor-pointer px-5 transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-105 hover:bg-gray-400 hover:text-black hover:border-black hover:border'
                  onClick={() => setSelectedStage(index === selectedStage ? null : index)}
                >
                  <div className='font-bold text-sm'>
                    {index + 1}. {item.name}
                  </div>
                  <IoIosArrowDown className='text-xl text-white' />
                </div>
                <div className={`${index === selectedStage ? 'h-44' : 'h-[0px]'} ${index === selectedStage ? 'p-3' : 'p-0'}  ${index === selectedStage ? 'border-2 ' : 'border-none'} overflow-y-auto transition-all duration-300 ease-in-out w-10/12 bg-white shadow-xl border-gray-500 rounded-b-md`}>
                  <div
                    className='h-8 w-44 flex items-center justify-center justify-self-end text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]'
                    onClick={() => {
                      setIsModalProbesOpen(true)
                    }}
                  >
                    Editar Sondeos <CiEdit className='ml-2 size-6' />
                  </div>
                  {
                    item.polls.map((pollItem, nIndex) => (
                      <div
                        key={nIndex}
                        className='h-11 w-full flex items-center px-3 bg-[#eaeaea] rounded-lg shadow-lg my-3 '
                      >
                        <div className='w-6/12 font-semibold overflow-x-auto whitespace-nowrap max-w-full'>
                          {index + 1}.{nIndex + 1} {pollItem.name}
                        </div>

                        <div className='w-5/12 flex flex-row space-x-4 text-[#898989]'>
                          <div className='flex flex-col'>
                            <label htmlFor={`required-${nIndex}`}>Obligatorio</label>
                            <input
                              type="radio"
                              id={`required-${index}-${nIndex}`}
                              name={`option-radio-${index}-${nIndex}`}
                              checked={pollItem.required === true}
                            />
                          </div>
                          {
                            role.id === ROLES.ADMIN && (
                              <div className='flex flex-col'>
                                <label htmlFor={`required-${nIndex}`}>Trackeo GPS</label>
                                <input
                                  type="radio"
                                  id={`isCheking-${index}-${nIndex}`}
                                  name={`option-radio-check-${index}-${nIndex}`}
                                  checked={pollItem.isCheking === true}
                                />
                              </div>
                            )
                          }
                        </div>
                        <div className='w-1/12'>
                          <div
                            className='h-8 w-8 flex justify-center items-center rounded-lg bg-white justify-self-end cursor-pointer hover:text-gray-600'
                            onClick={() => {
                              setIsModalQuestionsOpen(true)
                              setPollSelected(pollItem.id)
                              setTitlePoll(`${index + 1}.${nIndex + 1} ${pollItem.name}`)
                            }}
                          >
                            <FaSearch />
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            ))
          }
        </div>
        <ModalEditStages 
          isOpen={isModalOpen} 
          onClose={() => {
            setIsModalOpen(false);
            dispatch(getStages(workFlowSelected.id));
          }} 
          workFlowSelected={workFlowSelected} 
          stages={stages}
        />
        <ModalEditProbes 
          isOpen={isModalProbesOpen} 
          onClose={() => {
            setIsModalProbesOpen(false);
            dispatch(getStages(workFlowSelected.id));
          }} 
          polls={stages[selectedStage ?? 0]?.polls ?? []}
          nameStage={stages[selectedStage ?? 0]?.name ?? ""}
          idStage={stages[selectedStage ?? 0]?.id ?? 0}
          isIncident={stages[selectedStage ?? 0]?.isIncident ?? false}
        />
        <ModalEditQuestions 
          isOpen={isModalQuestionsOpen} 
          onClose={() => setIsModalQuestionsOpen(false)} 
          pollSelected={pollSelected}
          titlePoll={titlePoll}
        />
      </div>
    </>
  )
}

export default DetailsWorkFlows